import styled, { css } from "styled-components";
import { Header2 } from "../../styles/Headers";
import SubHeaderWithLinks from "../../styles/SubHeaderWithLinks";
import SoftSubTextBase from "../../styles/SoftSubText";
import { contentMobileQuery } from "../../constants/breakpoints";

export const KillerSectionShell = styled.section<{ $background?: string }>`
  align-self: stretch;
  width: 100%;
  min-height: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  background: ${({ $background }) => $background ?? "transparent"};

  @media (hover: hover) and (pointer: fine) {
    cursor: none;

    * {
      cursor: none !important;
    }
  }

  ${({ $background }) =>
    $background === "#ffffff" &&
    css`
      ${contentMobileQuery} {
        padding-bottom: 3.2rem;
        overflow: visible;
      }
    `}
`;

export const KillerTwoColumnLayout = styled.div<{
  $desktopOffset?: string;
  $mobileVariant?: "kgf" | "kitties";
  $gap?: string;
}>`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  gap: ${({ $gap }) => $gap ?? "clamp(3rem, 5vw, 6rem)"};
  max-width: 110rem;
  margin-top: 2rem;
  align-items: center;
  transform: ${({ $desktopOffset }) => $desktopOffset ?? "none"};

  ${contentMobileQuery} {
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 5rem;
    padding: 0;
    text-align: center;
    gap: 2.4rem;
    transform: none;

    ${({ $mobileVariant }) =>
      $mobileVariant === "kgf" &&
      css`
        margin-bottom: 1.6rem;
        padding: 0 clamp(1.8rem, 6vw, 3rem) 2.4rem;
      `}
  }

  @media only screen and (min-width: 601px) and (max-width: 1200px) {
    justify-content: flex-start;
    margin-top: 5rem;
    padding: 0 3rem;
    transform: none;
  }
`;

export const KillerTextColumn = styled.div<{ $variant?: "kgf" | "kitties" }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 46rem;
  max-width: 50rem;
  position: relative;
  z-index: 1;

  ${({ $variant }) =>
    $variant === "kgf"
      ? css`
          order: 2;

          @media only screen and (max-width: 1000px) {
            flex: 0 1 auto;
            max-width: 100%;
            order: 1;
          }
        `
      : css`
          @media only screen and (min-width: 601px) {
            order: 2;
          }

          @media only screen and (max-width: 1000px) {
            flex: 0 1 auto;
            max-width: 100%;
          }

          ${contentMobileQuery} {
            padding: 0 clamp(1.8rem, 6vw, 3rem);
          }
        `}
`;

export const KillerSubHeader = styled(SubHeaderWithLinks)`
  position: relative;
  z-index: 1;
`;

export const KillerSoftSubText = styled(SoftSubTextBase)`
  margin-top: 2rem;
  max-width: 58rem;
`;

export const KillerSectionTitle = styled(Header2)`
  ${contentMobileQuery} {
    font-size: 3.2rem;
    line-height: 1.05;
    margin-bottom: 1.8rem;
  }
`;
